function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Source = function Source(param) {
    var httpClient = param.httpClient, baseUrl = param.baseUrl;
    _class_call_check(this, Source);
    _define_property(this, "_baseUrl", void 0);
    _define_property(this, "_httpClient", void 0);
    this._baseUrl = baseUrl;
    this._httpClient = httpClient;
};

export { Source as default };
